import i from './page-header.container';

export default i;
